interface IPushLoginEventProps {
  id: string;
}

export function pushMenuTabCLickEvent({ id }: IPushLoginEventProps) {
  if ("dataLayer" in window) {
    window.dataLayer.push({
      event: "menu_tabs_click",
      id,
    });
  }
}
